import { SectionHeading } from "@/components/ui-ext/SectionHeading";
import { BrandFigure } from "@/components/media/BrandFigure";
import { siteConfig } from "@/config/site";

const ROWS = [
  ["Reporting cadence", "Automated PDF once a month", "Weekly async + monthly exec review"],
  ["KPIs", "Vanity: rankings, DA, DR", "Business: pipeline, CAC-adjusted revenue"],
  ["AI search optimisation", "Not offered or 'coming soon'", "AI Search Readiness Scorecard on every priority page"],
  ["Content ownership", "Ghost-written by a copywriter", "Briefs authored by SEO strategist + subject-matter reviewer"],
  ["Technical SEO", "Occasional audit", "Weekly crawl + CWV monitoring in Looker Studio"],
  ["Case studies", "Anonymous 'a leading SaaS'", "Named clients, dated windows, real GSC / Semrush screenshots"],
  ["Contract shape", "12-month lock-in", "Rolling engagement · 30-day exit for cause"],
  ["Who's on your account", "Junior account manager", "Senior strategist + technical lead on every call"],
];

export function HomeComparison() {
  return (
    <section className="container-page py-24 md:py-32">
      <SectionHeading
        eyebrow="How we're different"
        title={<>The <span className="text-gradient">{siteConfig.name}</span> standard vs the industry default.</>}
        intro="Compare us line by line against the agency you're currently paying — or the last one you fired."
      />
      <div className="mt-14 surface-card overflow-hidden">
        <div className="grid grid-cols-[1.1fr_1fr_1.2fr] text-[0.7rem] uppercase tracking-[0.18em] text-muted-foreground bg-surface-2 px-4 md:px-6 py-3">
          <div>Dimension</div>
          <div>Typical agency</div>
          <div className="text-primary">{siteConfig.name}</div>
        </div>
        <div>
          {ROWS.map(([dim, them, us], i) => (
            <div
              key={dim}
              className={`grid grid-cols-[1.1fr_1fr_1.2fr] gap-4 px-4 md:px-6 py-4 text-sm items-start ${
                i !== ROWS.length - 1 ? "border-b border-border" : ""
              }`}
            >
              <div className="font-medium text-foreground">{dim}</div>
              <div className="text-muted-foreground">{them}</div>
              <div className="text-foreground">
                <span className="inline-flex items-start gap-2">
                  <span className="mt-1 h-1.5 w-1.5 rounded-full bg-primary shrink-0" />
                  <span>{us}</span>
                </span>
              </div>
            </div>
          ))}
        </div>
      <BrandFigure
        className="mt-10"
        kind="rank-curve"
        title="Typical trajectory difference: a monthly-report retainer vs an instrumented growth program"
      />
      </div>
    </section>
  );
}
